import * as React from "react";
import { connect } from "react-redux";
import { IdDoghouse } from "../../constants/IdDoghouse";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { utilButton } from "../../utils/utilButton";
import { ButtonWithProgress } from "../button-with-progress/ButtonWithProgress";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
var _ButtonGiveTreat = function (_a) {
    var onClick = _a.onClick, lastTreatTimestamp = _a.lastTreatTimestamp;
    var isDisabled = lastTreatTimestamp !== 0;
    return isDisabled ? (React.createElement(ButtonWithProgress, { duration: IdDoghouse.GiveDogtreatCooldown, remainingTime: lastTreatTimestamp, disabled: true },
        React.createElement(TextLoca, { id: IdLoca.give, className: IdStyles.TextButtonDefault }))) : (React.createElement(ButtonPrimary, { onClick: function () { return utilButton.onClickWithSound(onClick, IdEventSoundCore.DogSniff); } },
        React.createElement(TextLoca, { id: IdLoca.give, className: IdStyles.TextButtonDefault })));
};
var mapState = function (state) { return ({
    lastTreatTimestamp: state.doghouse.cooldownTime,
}); };
export var ButtonGiveTreat = connect(mapState)(_ButtonGiveTreat);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/ButtonGiveTreat.tsx
// module id = 920
// module chunks = 3